"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentToken = void 0;
const PlatformToken_1 = require("../util/PlatformToken");
class AgentToken extends PlatformToken_1.PlatformToken {
    constructor(token) {
        super(AgentToken.AGENT_TOKEN_TYPE, token);
    }
    get agentId() {
        return this.subject;
    }
    get projectId() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.token.pid;
    }
    get launchRequestId() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.token.lrid;
    }
    get modelId() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this.token.mid;
    }
}
exports.AgentToken = AgentToken;
AgentToken.AGENT_TOKEN_TYPE = 'agent';
//# sourceMappingURL=AgentToken.js.map